module.exports = __webpack_public_path__ + "static/media/grand-resort-desktop.30fcc2a2.jpg";